import React, { Component } from 'react';
import {FormattedMessage} from 'react-intl';

class PaginationButton extends Component{

	render(){
		const {btnClassName, onClickHandler, langKey, iconClassName, isDisabled, type, isNext} = this.props;
		const className = isDisabled(type,isNext) ? btnClassName + " disabled" : btnClassName;
		if(isNext){
			return (
				<button className={className} onClick={e => onClickHandler(e,type,isNext)}>
					<FormattedMessage id={langKey} />
					<i className={iconClassName}/>
				</button>
			);
		}

		return (
			<button className={className} onClick={e => onClickHandler(e,type,isNext)}>
				<i className={iconClassName}/>
				<FormattedMessage id={langKey} />
			</button>
		);
	}
}

export default PaginationButton;


// WEBPACK FOOTER //
// ./src/components/common/PaginationButton.js